import type { MixedObject } from 'd2/types'

export function track2 (_eventName: string, _properties?: MixedObject | null): void {
  // TODO: Implement for google analytics
}
